function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff9583;}.cls-2,.cls-3{fill:#495771;}.cls-3{stroke:#495771;stroke-miterlimit:10;}.cls-4{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "BoxDelivery");

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "59.51 41.67 92.88 7.11 92.88 48.56 79.88 62.03 59.51 41.67"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "61 7.11 61 31.11 50 21.11 39 31.11 39 7.11 61 7.11"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M91,84.11H64.64v-2H91a1,1,0,0,0,1-1V48h2V81.11A3,3,0,0,1,91,84.11Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.9,90a6.43,6.43,0,0,1-3.41-1,6.76,6.76,0,0,1-2.92-4,3,3,0,0,1,.22-2c.08-.15.16-.26.23-.38l.14-.2c2.22-3.18,9.86-14.07,14.7-20.74l1.62,1.17C37.65,69.49,30,80.37,27.8,83.54l-.13.19-.11.18a1,1,0,0,0-.06.69,4.68,4.68,0,0,0,2,2.77,4.77,4.77,0,0,0,3.62.5,1,1,0,0,0,.6-.42L43.3,73.37,45,74.49,35.42,88.55a3,3,0,0,1-1.8,1.26A7.62,7.62,0,0,1,31.9,90Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M40.21,92.49a5.74,5.74,0,0,1-3.14-.91,6,6,0,0,1-2.65-4.82h2a4,4,0,0,0,1.74,3.14,3.88,3.88,0,0,0,3.83.16,1,1,0,0,0,.32-.32L50,77.65l1.69,1.07L44,90.83a2.82,2.82,0,0,1-1.11,1A6,6,0,0,1,40.21,92.49Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M48.64,93.73A5.61,5.61,0,0,1,45.81,93a6,6,0,0,1-2.76-3.83l2-.44a3.73,3.73,0,0,0,4.37,3l.25-.06a1,1,0,0,0,.57-.43l5.87-9.62,1.71,1L51.9,92.23a3,3,0,0,1-1.82,1.33A6.37,6.37,0,0,1,48.64,93.73Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M57,93.89a5.16,5.16,0,0,1-5.15-5,1,1,0,0,1,2,0,3.18,3.18,0,0,0,3.31,3,3.27,3.27,0,0,0,1.11-.26,1,1,0,0,0,.47-.44l13.85-27a1,1,0,1,1,1.78.92h0L60.49,92.1A3,3,0,0,1,59,93.47,5.27,5.27,0,0,1,57,93.89Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M26.46,84.11H9a3,3,0,0,1-3-3v-72a3,3,0,0,1,3-3H93a1,1,0,1,1,0,2H9a1,1,0,0,0-1,1v72a1,1,0,0,0,1,1H26.46a1,1,0,0,1,0,2Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M31.77,68h-.68A8.73,8.73,0,0,1,25,64.31a1,1,0,0,1,.26-1.39L41.12,52.1a16,16,0,0,1,9-2.78l8.25-.62a1,1,0,0,1,.15,2l-8.32.62a14,14,0,0,0-8,2.44L27.26,64a6.39,6.39,0,0,0,4,2.06,6.1,6.1,0,0,0,3.09-.58l6.8-4.06a1,1,0,0,1,1,1.72L35.3,67.2A8.14,8.14,0,0,1,31.77,68Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M75.43,68.08l-2.66-2.65-18-18L60,42.17l.77.65.7.71-3.89,3.9,17.81,17.8L92.16,47.87a1,1,0,0,1,1.44,1.38l-1.4,1.46Z"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-3",
  points: "79.13 62.7 58.1 41.69 92.16 6.42 93.6 7.81 60.91 41.66 61.46 42.2 80.55 61.29 79.13 62.7"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-4",
  width: 100,
  height: 100
});

var SvgBoxDelivery = function SvgBoxDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BoxDelivery.6d86104b.svg";
export { ForwardRef as ReactComponent };